<app-anonymous-page-layout>
  <app-card>
    <app-page-title [title]="'PAGE.WELCOME.TITLE' | translate" style="--page-title-padding-bottom: var(--size-xl)"></app-page-title>
    <p style="text-align: center">{{ 'PAGE.WELCOME.DESCRIPTION' | translate }}</p>
  </app-card>
</app-anonymous-page-layout>
